import { useEffect } from 'react';

// Fail-closed SA gating (runtime complement to saGeo.css).
// The CSS gate hides direct tel: links and <a href="/one-on-one-support">
// for non-SA visitors, but it can't reach actionable elements that
// advertise One on One Support without that href - e.g. modal-opening
// <button>s or <Link to="/contact"> CTAs. This observer tags any such
// link/button with data-sa-only, which saGeo.css then hides for anyone
// we can't confirm is in South Australia. Tagging is geo-agnostic and
// harmless under data-geo="sa" (the CSS only hides under non-sa).
const ONE_ON_ONE = /one[\s\u2010\u2011-]*on[\s\u2010\u2011-]*one\s*support/i;

function tagActionables() {
  const nodes = document.querySelectorAll('a, button, [role="button"]');
  for (const el of nodes) {
    if (el.getAttribute('data-sa-only') === 'auto') continue;
    const text = (el.textContent || '').trim();
    if (text.length > 0 && text.length <= 70 && ONE_ON_ONE.test(text)) {
      el.setAttribute('data-sa-only', 'auto');
    }
  }
}

export default function SAContactGuard() {
  useEffect(() => {
    let raf = 0;
    const schedule = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(tagActionables);
    };
    schedule();
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => {
      if (raf) cancelAnimationFrame(raf);
      obs.disconnect();
    };
  }, []);
  return null;
}
